// extracted by mini-css-extract-plugin
export var category = "_k9-9";
export var categoryHeader = "_k9-e";
export var container = "_k9-0";
export var group = "_k9-a";
export var groupItems = "_k9-f";
export var groupSeparator = "_k9-j";
export var loading = "_k9-1";
export var noResults = "_k9-3";
export var placeholder = "_k9-2";
export var resultContent = "_k9-5";
export var resultIcon = "_k9-c";
export var resultItem = "_k9-g";
export var resultMeta = "_k9-8";
export var resultSubtitle = "_k9-7";
export var resultSuffix = "_k9-i";
export var resultTitle = "_k9-6";
export var resultsList = "_k9-4";
export var searchGroup = "_k9-d";
export var selected = "_k9-h";
export var subgroup = "_k9-b";